import * as React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import MainCentumVP from './components/MainPage/dcs/centumvp/Main';
import MainDcsExperion from './components/MainPage/dcs/experion/Main';
import MainPole from './components/MainPage/pole/Main';
import './custom.css';

import WebElement from './components/MainPage/webelement/Main';
// @ts-ignore
import { loadPolicy } from '@open-policy-agent/opa-wasm';
import EasySettings from './components/MainControl/EasySettings';
import MainControl from './components/MainControl/MainControl';
import Settings from './components/MainControl/Settings/Settings';

import WindowGlobalArea from './components/MainControl/WindowManager/WindowGlobalArea';

import { ConnectionWrapper } from 'components/containers/connection/ConnectionWrapper';
import { useKeyCloakActivity } from 'hooks';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStores } from 'store';
import Configuration from './components/Configuration/Configuration';

function App() {
    const [authorize, setAuthorize] = useState<boolean>(true);
    const { AuthStore, SystemStore } = useStores();
    const [nameUser, setNameUser] = useState<string>('');
    const [settingTrue, setSettingTrue] = useState<boolean>(false);
    const isInactive = useKeyCloakActivity(AuthStore.InactivityTimout);

    useEffect(() => {
        if (isInactive) Logout();
    }, [isInactive]);

    useEffect(() => {
        fetch('/ixyber/vision/Auth/UseAuthorize')
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                setAuthorize(data.authority);
            })
            .catch((errorData) => {
                console.error('Failed to load Data: ', errorData);
            });

        return () => {};
    }, []);

    useEffect(() => {
        if (AuthStore?.user != null && AuthStore?.accessRoles != null) {
            setNameUser(
                AuthStore.user.givenName[0] + ' ' + AuthStore.user.middleName[0] + ' ' + AuthStore.user.familyName
            );
            readPolicy(window.location.pathname, AuthStore.user.id, AuthStore.accessRoles);
        }

        return () => {
            document.cookie = 'page=' + window.location.pathname + ';path=/';
        };
    }, [AuthStore]);

    const Login = () => {
        document.cookie = 'user=;roles=;page=;path=/';
        AuthStore.keyClock?.login();
    };
    const Logout = () => {
        document.cookie = 'user=;roles=;page=;path=/';
        AuthStore.keyClock?.logout();
    };

    function getCookie(name: string) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');

        if (parts.length == 2) {
            return parts.pop()?.split(';').shift();
        }
    }

    const readPolicy = (_path: string, user: string, roles: string[]) => {
        fetch('/ixyber/vision/policy.wasm')
            .then((response) => {
                return response.arrayBuffer();
            })
            .then((policyWasm) => {
                loadPolicy(policyWasm)
                    .then((policy: any) => {
                        fetch('/ixyber/vision/auth/permission')
                            .then((res) => {
                                return res.json();
                            })
                            .then((data) => {
                                if (getCookie('user') == '' && user != '') {
                                    document.cookie = 'user=' + user + ';path=/';
                                    document.cookie = 'roles=' + roles.join('&') + ';path=/';
                                }

                                let input = { user: user, path: _path, roles: roles };
                                policy.setData(data);
                                let resultSet = policy.evaluate(input);

                                if (resultSet == null) {
                                    console.error('evaluation error');
                                } else if (resultSet.length == 0) {
                                    console.debug('undefined');
                                } else {
                                    if (getCookie('user') == user || AuthStore.keyClock == undefined) {
                                        if (!resultSet[0].result) {
                                            window.location.href =
                                                window.location.origin + '/ixyber/vision/display/base';
                                        }
                                    }
                                    if (!AuthStore.keyClock?.authenticated) {
                                        if (!resultSet[0].result) {
                                            window.location.href =
                                                window.location.origin + '/ixyber/vision/display/base';
                                        }
                                    }
                                }
                                // let inputSet = { user: user, path: 'setting', roles: roles };
                                // let result = policy.evaluate(inputSet);
                                // if (result != null && result.length != 0) {
                                //     if (settingTrue != result[0].result) setSettingTrue(result[0].result);
                                // }
                                if (roles.includes('Admin')) {
                                    setSettingTrue(true);
                                }
                            })
                            .catch((errorData: any) => {
                                console.error('Failed to load Data: ', errorData);
                            });
                    })
                    .catch((error: any) => {
                        console.error('Failed to load policy: ', error);
                    });
            });
    };

    function ExternalEditorPage() {
        global.window.location.replace('/ixyber/vision/EditorVision/page');

        return null;
    }

    useEffect(() => {
        SystemStore.setLoad();
    }, []);

    return (
        <ConnectionWrapper>
            <BrowserRouter>
                <Routes>
                    <Route path="/ixyber/vision/display/webelement" element={<WebElement />} />
                    <Route path="/ixyber/vision/display/experion" element={<MainDcsExperion />} />
                    <Route path="/ixyber/vision/display/centumvp" element={<MainCentumVP />} />
                    <Route path="/ixyber/vision/display/pole" element={<MainPole />} />
                    <Route path="/ixyber/vision/display/EditorVision" element={<ExternalEditorPage />} />
                    <Route
                        path="/ixyber/vision/display/base"
                        element={
                            <MainControl
                                auth={{
                                    visibleAuth: authorize,
                                    authenticated: AuthStore.authenticated,
                                    nameUser: nameUser,
                                    settingTrue: settingTrue,
                                    callbackLogin: () => {
                                        Login();
                                    },
                                    callbackLogout: () => {
                                        Logout();
                                    }
                                }}
                            />
                        }
                    />
                    <Route
                        path="/ixyber/vision/display/settingapc"
                        element={
                            <WindowGlobalArea>
                                {' '}
                                <EasySettings
                                    auth={{
                                        visibleAuth: authorize,
                                        authenticated: AuthStore.authenticated,
                                        nameUser: nameUser,
                                        settingTrue: settingTrue,
                                        callbackLogin: () => {
                                            Login();
                                        },
                                        callbackLogout: () => {
                                            Logout();
                                        }
                                    }}
                                />
                            </WindowGlobalArea>
                        }
                    />
                    <Route
                        path="/ixyber/vision/display/settingmain"
                        element={
                            AuthStore.authenticated && AuthStore.keyClock?.authenticated ? (
                                <WindowGlobalArea>
                                    <Settings
                                        auth={{
                                            visibleAuth: authorize,
                                            authenticated: AuthStore.authenticated,
                                            nameUser: nameUser,
                                            settingTrue: settingTrue,
                                            callbackLogin: () => {
                                                Login();
                                            },
                                            callbackLogout: () => {
                                                Logout();
                                            }
                                        }}
                                    />
                                </WindowGlobalArea>
                            ) : (
                                <Navigate to="/login" replace={true} state={{ callLogin: Login() }} />
                            )
                        }
                    />
                    <Route
                        path="/ixyber/vision/display/configuration"
                        element={
                            <WindowGlobalArea>
                                {' '}
                                <Configuration
                                    auth={{
                                        visibleAuth: authorize,
                                        authenticated: AuthStore.authenticated,
                                        nameUser: nameUser,
                                        settingTrue: settingTrue,
                                        callbackLogin: () => {
                                            Login();
                                        },
                                        callbackLogout: () => {
                                            Logout();
                                        }
                                    }}
                                />
                            </WindowGlobalArea>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </ConnectionWrapper>
    );
}

export default observer(App);
